import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Api from '../../services/ApiService';

class ReportWidget extends Component {
  constructor(props) {
    super(props);

    this.cols = {};
    this.pageConfig = {};
    this.timers = [];
  }

  componentDidMount() {
    this.getPage(this.props.pageName).then(() => {
      this.getData();
    });

    this.timers.push(
      setInterval(() => {
        if (document.visibilityState === 'hidden') {
          return;
        }
        this.getData();
      }, this.props.updateInterval)
    );
  }

  componentWillUnmount() {
    this.timers.map(clearInterval);
  }

  getData() {
    return Api.getReportData(this.props.pageName, {
      reportOptions: this.props.reportOptions,
      useCache: true,
      skipLog: true,
    }).then(data => {
      this.props.handleData({
        data,
        cols: this.cols,
        pageConfig: this.pageConfig,
      });
    });
  }

  getPage(pageName) {
    return Api.getPageConfig(pageName, { widget: 1 }).then(pageConfig => {
      this.pageConfig = pageConfig;
      this.cols = _.keyBy(_.get(this.pageConfig, ['translations', pageName, 'cols']), 'index');
      return Promise.resolve(pageConfig);
    });
  }

  render() {
    return <>{this.props.children}</>;
  }
}

ReportWidget.defaultProps = {
  reportOptions: [],
  updateInterval: 1000 * 60 * 15, // 15min
};

ReportWidget.propTypes = {
  children: PropTypes.any,
  handleData: PropTypes.func,
  pageName: PropTypes.string,
  reportOptions: PropTypes.array,
  updateInterval: PropTypes.number,
};

export default ReportWidget;
